var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-iframe-wrap touch-enable",on:{"click":_vm.set_ops}},[(_vm.gisMapUrl)?_c('iframe',{ref:"iframe",staticClass:"map-iframe touch-enable",attrs:{"src":_vm.gisMapUrl},on:{"load":_vm.handleLoad}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }